var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_578_25161)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 52.5,
    fill: "url(#paint0_radial_578_25161)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 52.5,
    fill: "url(#paint1_radial_578_25161)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5199,
    cy: 62.8159,
    r: 45.5219,
    transform: "rotate(-150 63.5199 62.8159)",
    fill: "url(#paint2_radial_578_25161)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5199,
    cy: 62.8159,
    r: 45.5219,
    transform: "rotate(-150 63.5199 62.8159)",
    fill: "url(#paint3_radial_578_25161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.384 52.7305V55.2109H44.6262V60.9141H41.5207V55.2109H34.8996V52.7305H51.384ZM36.716 51.1094V43.6875H49.5285V51.1094H36.716ZM39.7824 48.668H46.4035V46.1484H39.7824V48.668ZM67.4887 56.5391V59.0781H50.9848V56.5391H54.9496V54.1953H52.7816V47.8086H62.6059V46.4414H52.7621V43.9414H65.7113V50.2695H55.9262V51.6758H66.1215V54.1953H63.7582V56.5391H67.4887ZM57.9965 56.5391H60.6723V54.1953H57.9965V56.5391ZM74.4527 44.8594V59H70.7223V48.2969H70.6441L67.5191 50.1719V46.9883L71.0152 44.8594H74.4527ZM91.0262 42.8672V60.9336H87.9207V42.8672H91.0262ZM75.6941 55.6602C76.9637 55.6602 78.409 55.6602 79.9324 55.6309V54.3613C78.0867 53.9414 76.8855 52.7109 76.8855 51.1094C76.8855 49.0977 78.7898 47.6914 81.4754 47.6914C84.2 47.6914 86.1336 49.0977 86.1434 51.1094C86.1336 52.7012 84.9227 53.9316 83.0574 54.3613V55.5234C84.4148 55.4453 85.7625 55.3281 87.0613 55.1523L87.2566 57.457C83.3797 58.1602 79.2293 58.1895 76.0848 58.1797L75.6941 55.6602ZM76.0457 47.1836V44.7617H79.9324V43.0039H83.077V44.7617H86.9441V47.1836H76.0457ZM79.8738 51.1094C79.8738 51.8613 80.5477 52.1836 81.4754 52.1836C82.4813 52.1836 83.1355 51.8613 83.1355 51.1094C83.1355 50.3867 82.4813 50.0547 81.4754 50.0352C80.5477 50.0547 79.8738 50.3867 79.8738 51.1094ZM53.7332 70.6367V73.0586H48.9871V73.8984H55.6668V76.3398H39.1824V73.8984H45.823V73.0586H41.1551V67.4141H53.616V69.8945H44.2605V70.6367H53.7332ZM41.0184 84.8555V79.7773H50.6277V79.2109H41.0379V76.9453H53.7137V81.9062H44.0848V82.5117H54.1434V84.8555H41.0184ZM70.541 66.8672V84.9922H67.416V66.8672H70.541ZM56.1855 80.8516V73.1562H61.6738V70.793H56.1855V68.293H64.877V75.5977H59.4277V78.3027C62.0059 78.2734 64.125 78.1172 66.4199 77.7266L66.6738 80.2461C63.9395 80.7637 61.3027 80.8613 57.8848 80.8516H56.1855ZM86.6848 66.8672V84.9336H83.5012V66.8672H86.6848ZM71.3137 79.5625C75.8156 77.4238 77.6223 74.9434 78.0324 71.1641H72.3488V68.7227H81.216C81.2258 74.377 79.6242 78.8984 72.9152 82.0234L71.3137 79.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_578_25161",
    x: -4,
    y: 0,
    width: 135.04,
    height: 135.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_578_25161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_578_25161",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_578_25161",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.395 11) rotate(134.696) scale(147.71 9053.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_578_25161",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.395 11) rotate(134.696) scale(147.71 9053.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_578_25161",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.518 17.294) rotate(134.696) scale(128.077 7850.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_578_25161",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.518 17.294) rotate(134.696) scale(128.077 7850.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484416,
    stopColor: "#D23760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D23755"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinButton);
export default __webpack_public_path__ + "static/media/spin-button.0f4dc8470d78c2c9695aaf380e114f24.svg";
export { ForwardRef as ReactComponent };